import { render, staticRenderFns } from "./ConfirmMailMobileCard.vue?vue&type=template&id=498f041e&scoped=true&"
import script from "./ConfirmMailMobileCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmMailMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMailMobileCard.vue?vue&type=style&index=0&id=498f041e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f041e",
  null
  
)

export default component.exports